import {FC} from 'react'

type Props = {  
    className?:string
  }
  
const TicketHeader: FC<Props> = ({className}) => {
    return (
        <div className={`${className} d-flex`}>
        </div>
        
    )
}

export {TicketHeader}